(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TestPlanRunnerController', TestPlanRunnerController);

    TestPlanRunnerController.$inject = ['$scope', '$stateParams', 'AlertService', 'TestPlan'];

    function TestPlanRunnerController($scope, $stateParams, AlertService, TestPlan) {
        var vm = this;

        vm.planKey = $stateParams.planKey;
        vm.myPlans = [];
        vm.currentPlan = null;
        vm.currentResult = null;
        vm.currentSummary = null;
        vm.selectedDomain = null;
        vm.isChoosingPlan = true;
        vm.isIntroCollapsed = false;
        vm.scenarioPanels = {};
        vm.scenarioResultsByKey = {};
        vm.loadPlan = loadPlan;
        vm.choosePlan = choosePlan;
        vm.toggleIntro = toggleIntro;
        vm.selectDomain = selectDomain;
        vm.previousDomain = previousDomain;
        vm.nextDomain = nextDomain;
        vm.hasPreviousDomain = hasPreviousDomain;
        vm.hasNextDomain = hasNextDomain;
        vm.getSelectedDomainIndex = getSelectedDomainIndex;
        vm.isSelectedDomain = isSelectedDomain;
        vm.isDomainStarted = isDomainStarted;
        vm.isDomainCompleted = isDomainCompleted;
        vm.getScenarioKey = getScenarioKey;
        vm.getScenarioResult = getScenarioResult;
        vm.getScenarioResponseType = getScenarioResponseType;
        vm.isStatusQuestion = isStatusQuestion;
        vm.isRatingQuestion = isRatingQuestion;
        vm.isSmileyQuestion = isSmileyQuestion;
        vm.getScenarioState = getScenarioState;
        vm.getScenarioStatusLabelKey = getScenarioStatusLabelKey;
        vm.getScenarioCommentPreview = getScenarioCommentPreview;
        vm.isScenarioExpanded = isScenarioExpanded;
        vm.toggleScenario = toggleScenario;
        vm.onScenarioCommentBlur = onScenarioCommentBlur;
        vm.setScenarioStatus = setScenarioStatus;
        vm.selectScenarioRating = selectScenarioRating;
        vm.selectScenarioSmiley = selectScenarioSmiley;
        vm.getSmileyLabelKey = getSmileyLabelKey;
        vm.getSmileyImagePath = getSmileyImagePath;
        vm.handleCommentPaste = handleCommentPaste;
        vm.removeAttachment = removeAttachment;
        vm.save = save;
        vm.domainProgress = domainProgress;

        activate();

        function activate() {
            TestPlan.myPlans(function(result) {
                vm.myPlans = result || [];
                if (vm.myPlans.length === 0) {
                    return;
                }

                if (vm.planKey) {
                    var selected = vm.myPlans[0];
                    vm.myPlans.forEach(function(plan) {
                        if (plan.storageKey === vm.planKey) {
                            selected = plan;
                        }
                    });
                    loadPlan(selected.storageKey);
                }
            });
        }

        function choosePlan() {
            vm.isChoosingPlan = true;
            vm.currentPlan = null;
            vm.currentResult = null;
            vm.currentSummary = null;
            vm.selectedDomain = null;
            vm.isIntroCollapsed = false;
            vm.scenarioPanels = {};
            vm.scenarioResultsByKey = {};
        }

        function loadPlan(storageKey) {
            if (!storageKey) {
                return;
            }
            vm.planKey = storageKey;
            vm.isIntroCollapsed = false;
            vm.scenarioPanels = {};
            TestPlan.myPlan({ storageKey: storageKey }, function(result) {
                vm.currentPlan = result.plan;
                vm.currentResult = result.result;
                vm.currentSummary = result.summary;
                indexScenarioResults();
                restoreSelectedDomain();
                vm.isChoosingPlan = false;
            }, function(response) {
                var errorDetail = response.headers('X-wamasysApp-detail');
                AlertService.error(errorDetail || 'Impossible de charger le plan de test.');
            });
        }

        function toggleIntro() {
            vm.isIntroCollapsed = !vm.isIntroCollapsed;
        }

        function selectDomain(domain) {
            vm.selectedDomain = domain;
        }

        function previousDomain() {
            moveToDomain(-1);
        }

        function nextDomain() {
            moveToDomain(1);
        }

        function hasPreviousDomain() {
            return getSelectedDomainIndex() > 0;
        }

        function hasNextDomain() {
            var currentIndex = getSelectedDomainIndex();
            return currentIndex > -1 && vm.currentPlan && vm.currentPlan.domains && currentIndex < vm.currentPlan.domains.length - 1;
        }

        function getSelectedDomainIndex() {
            return findDomainIndex(vm.selectedDomain ? vm.selectedDomain.domainId : null);
        }

        function isSelectedDomain(domain) {
            return !!domain && !!vm.selectedDomain && domain.domainId === vm.selectedDomain.domainId;
        }

        function getScenarioKey(domainId, scenarioId) {
            return domainId + '::' + scenarioId;
        }

        function getScenarioResult(domainId, scenarioId) {
            return vm.scenarioResultsByKey[getScenarioKey(domainId, scenarioId)] || null;
        }

        function getScenarioResponseType(scenario) {
            return scenario && scenario.responseType ? scenario.responseType : 'STATUS';
        }

        function isStatusQuestion(scenario) {
            return getScenarioResponseType(scenario) === 'STATUS';
        }

        function isRatingQuestion(scenario) {
            return getScenarioResponseType(scenario) === 'RATING_10';
        }

        function isSmileyQuestion(scenario) {
            return getScenarioResponseType(scenario) === 'SMILEY_4';
        }

        function getScenarioState(scenarioResult) {
            if (!scenarioResult || !scenarioResult.status || scenarioResult.status === 'NOT_TESTED') {
                return 'pending';
            }
            if (scenarioResult.status === 'UNABLE_TO_ANSWER') {
                return 'unable';
            }
            if (scenarioResult.status === 'ANSWERED') {
                return scenarioResult.answerValue !== null && scenarioResult.answerValue !== undefined ? 'answered' : 'pending';
            }
            if (scenarioResult.status === 'OK') {
                return 'ok';
            }
            if (scenarioResult.status === 'KO' && hasKoComment(scenarioResult)) {
                return 'ko';
            }
            return 'ko-pending';
        }

        function getScenarioStatusLabelKey(scenarioResult) {
            var state = getScenarioState(scenarioResult);
            if (state === 'ok') {
                return 'testPlan.runner.scenarioStatusOk';
            }
            if (state === 'ko') {
                return 'testPlan.runner.scenarioStatusKo';
            }
            if (state === 'ko-pending') {
                return 'testPlan.runner.scenarioStatusKoPending';
            }
            if (state === 'answered') {
                return 'testPlan.runner.scenarioStatusAnswered';
            }
            if (state === 'unable') {
                return 'testPlan.runner.scenarioStatusUnable';
            }
            return 'testPlan.runner.scenarioStatusPending';
        }

        function getScenarioCommentPreview(scenarioResult) {
            if (!scenarioResult || !scenarioResult.comment) {
                return '';
            }

            var compactComment = scenarioResult.comment.replace(/\s+/g, ' ').trim();
            if (compactComment.length <= 110) {
                return compactComment;
            }
            return compactComment.substring(0, 107) + '...';
        }

        function isScenarioExpanded(domainId, scenarioId) {
            var scenarioKey = getScenarioKey(domainId, scenarioId);
            if (vm.scenarioPanels.hasOwnProperty(scenarioKey)) {
                return vm.scenarioPanels[scenarioKey];
            }
            return !isScenarioCompleted(getScenarioResult(domainId, scenarioId));
        }

        function toggleScenario(domainId, scenarioId) {
            setScenarioExpanded(domainId, scenarioId, !isScenarioExpanded(domainId, scenarioId));
        }

        function onScenarioCommentBlur(domainId, scenarioId) {
            var scenarioResult = getScenarioResult(domainId, scenarioId);
            if (isScenarioCompleted(scenarioResult)) {
                setScenarioExpanded(domainId, scenarioId, false);
            }
        }

        function setScenarioStatus(domainId, scenarioId, status) {
            var result = getScenarioResult(domainId, scenarioId);
            if (!result) {
                return;
            }

            result.status = status;
            if (status !== 'ANSWERED') {
                result.answerValue = null;
            }

            // Completed answers collapse automatically to keep the remaining work visible.
            if (status === 'OK' || status === 'UNABLE_TO_ANSWER') {
                setScenarioExpanded(domainId, scenarioId, false);
                return;
            }
            if (status === 'KO') {
                setScenarioExpanded(domainId, scenarioId, !hasKoComment(result));
                return;
            }
            setScenarioExpanded(domainId, scenarioId, true);
        }

        function selectScenarioRating(domainId, scenarioId, value) {
            setScenarioAnswerValue(domainId, scenarioId, value);
        }

        function selectScenarioSmiley(domainId, scenarioId, value) {
            setScenarioAnswerValue(domainId, scenarioId, value);
        }

        function setScenarioAnswerValue(domainId, scenarioId, value) {
            var result = getScenarioResult(domainId, scenarioId);
            if (!result) {
                return;
            }
            result.status = 'ANSWERED';
            result.answerValue = value;
            setScenarioExpanded(domainId, scenarioId, false);
        }

        function getSmileyLabelKey(value) {
            if (value === 1) {
                return 'testPlan.runner.smiley1';
            }
            if (value === 2) {
                return 'testPlan.runner.smiley2';
            }
            if (value === 3) {
                return 'testPlan.runner.smiley3';
            }
            return 'testPlan.runner.smiley4';
        }

        function getSmileyImagePath(value) {
            if (value === 1) {
                return 'content/images/wamasys_smiley_fache.png';
            }
            if (value === 2) {
                return 'content/images/wamasys_smiley_mitige.png';
            }
            if (value === 3) {
                return 'content/images/wamasys_smiley_ok.png';
            }
            return 'content/images/wamasys_smiley_very_happy.png';
        }

        function handleCommentPaste($event, scenarioResult) {
            if (!scenarioResult || !$event || !$event.clipboardData || !$event.clipboardData.items) {
                return;
            }

            var imageItems = [];
            angular.forEach($event.clipboardData.items, function(item) {
                if (item && item.type && item.type.indexOf('image/') === 0) {
                    imageItems.push(item);
                }
            });
            if (imageItems.length === 0) {
                return;
            }

            if (!scenarioResult.attachments) {
                scenarioResult.attachments = [];
            }

            $event.preventDefault();
            angular.forEach(imageItems, function(item, index) {
                var file = item.getAsFile();
                if (!file) {
                    return;
                }
                var reader = new FileReader();
                reader.onload = function(loadEvent) {
                    $scope.$applyAsync(function() {
                        scenarioResult.attachments.push({
                            fileName: file.name || ('capture-' + (scenarioResult.attachments.length + index + 1) + '.png'),
                            contentType: file.type || 'image/png',
                            dataUrl: loadEvent.target.result
                        });
                    });
                };
                reader.readAsDataURL(file);
            });
        }

        function removeAttachment(scenarioResult, attachmentIndex) {
            if (!scenarioResult || !scenarioResult.attachments) {
                return;
            }
            scenarioResult.attachments.splice(attachmentIndex, 1);
        }

        function save() {
            if (!vm.planKey || !vm.currentResult) {
                return;
            }

            var selectedDomainId = vm.selectedDomain ? vm.selectedDomain.domainId : null;
            TestPlan.saveMyPlan({ storageKey: vm.planKey }, vm.currentResult, function(result) {
                vm.currentPlan = result.plan;
                vm.currentResult = result.result;
                vm.currentSummary = result.summary;
                indexScenarioResults();
                restoreSelectedDomain(selectedDomainId);
            }, function(response) {
                var errorDetail = response.headers('X-wamasysApp-detail');
                AlertService.error(errorDetail || 'Impossible d\'enregistrer votre résultat.');
            });
        }

        function domainProgress(domain) {
            if (!domain || !domain.scenarios || domain.scenarios.length === 0) {
                return '0/0';
            }

            return countCompletedScenarios(domain) + '/' + domain.scenarios.length;
        }

        function isDomainStarted(domain) {
            if (!domain || !domain.scenarios || domain.scenarios.length === 0) {
                return false;
            }

            return countStartedScenarios(domain) > 0 && !isDomainCompleted(domain);
        }

        function isDomainCompleted(domain) {
            return !!domain && !!domain.scenarios && domain.scenarios.length > 0
                && countCompletedScenarios(domain) === domain.scenarios.length;
        }

        function countStartedScenarios(domain) {
            var startedCount = 0;
            domain.scenarios.forEach(function(scenario) {
                if (isScenarioStarted(getScenarioResult(domain.domainId, scenario.scenarioId))) {
                    startedCount++;
                }
            });
            return startedCount;
        }

        function countCompletedScenarios(domain) {
            var completedCount = 0;
            domain.scenarios.forEach(function(scenario) {
                if (isScenarioCompleted(getScenarioResult(domain.domainId, scenario.scenarioId))) {
                    completedCount++;
                }
            });
            return completedCount;
        }

        function moveToDomain(offset) {
            var currentIndex = getSelectedDomainIndex();
            if (!vm.currentPlan || !vm.currentPlan.domains || currentIndex < 0) {
                return;
            }

            var nextIndex = currentIndex + offset;
            if (nextIndex < 0 || nextIndex >= vm.currentPlan.domains.length) {
                return;
            }

            vm.selectedDomain = vm.currentPlan.domains[nextIndex];
        }

        function restoreSelectedDomain(preferredDomainId) {
            if (!vm.currentPlan || !vm.currentPlan.domains || vm.currentPlan.domains.length === 0) {
                vm.selectedDomain = null;
                return;
            }

            var selectedDomain = vm.currentPlan.domains[0];
            if (preferredDomainId !== undefined && preferredDomainId !== null) {
                vm.currentPlan.domains.forEach(function(domain) {
                    if (domain.domainId === preferredDomainId) {
                        selectedDomain = domain;
                    }
                });
            }
            vm.selectedDomain = selectedDomain;
        }

        function findDomainIndex(domainId) {
            if (!vm.currentPlan || !vm.currentPlan.domains || domainId === undefined || domainId === null) {
                return -1;
            }

            var foundIndex = -1;
            vm.currentPlan.domains.forEach(function(domain, index) {
                if (domain.domainId === domainId) {
                    foundIndex = index;
                }
            });
            return foundIndex;
        }

        function indexScenarioResults() {
            vm.scenarioResultsByKey = {};
            if (!vm.currentResult || !vm.currentResult.scenarioResults) {
                return;
            }

            vm.currentResult.scenarioResults.forEach(function(item) {
                vm.scenarioResultsByKey[getScenarioKey(item.domainId, item.scenarioId)] = item;
            });
        }

        function isScenarioStarted(scenarioResult) {
            return !!scenarioResult && !!scenarioResult.status && scenarioResult.status !== 'NOT_TESTED';
        }

        function isScenarioCompleted(scenarioResult) {
            if (!isScenarioStarted(scenarioResult)) {
                return false;
            }
            if (scenarioResult.status === 'UNABLE_TO_ANSWER' || scenarioResult.status === 'OK') {
                return true;
            }
            if (scenarioResult.status === 'ANSWERED') {
                return scenarioResult.answerValue !== null && scenarioResult.answerValue !== undefined;
            }
            return scenarioResult.status === 'KO' && hasKoComment(scenarioResult);
        }

        function hasKoComment(scenarioResult) {
            return !!scenarioResult && !!scenarioResult.comment && scenarioResult.comment.trim().length > 0;
        }

        function setScenarioExpanded(domainId, scenarioId, expanded) {
            vm.scenarioPanels[getScenarioKey(domainId, scenarioId)] = expanded;
        }
    }
})();
